import { Link, Typography } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';
import { BOOK_CALL } from '@/karehero-app/tell-us-once/intake/content';

// The end of the intake: a person to check it with, offered rather than
// required. Nothing here submits anything.
const BookCallScreen = ({
  onBook,
  onSkip,
  account,
}: {
  onBook?: () => void;
  onSkip?: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <StepScreen
    account={account}
    title={BOOK_CALL.title}
    description={BOOK_CALL.description}
    primaryLabel={BOOK_CALL.primary}
    onPrimary={() => onBook?.()}
    footnote={
      <Link component='button' type='button' variant='caption' onClick={onSkip}>
        <Typography variant='caption'>{BOOK_CALL.secondary}</Typography>
      </Link>
    }
  />
);

export default BookCallScreen;
